import { createFileRoute } from "@tanstack/react-router";
import { SurveyPage } from "@/features/survey/SurveyPage";

/** Public survey page for one survey link. Sits outside the _app layout, so there is no app shell. */
export const Route = createFileRoute("/p/survey/$token")({
  component: SurveyRoute,
});

function SurveyRoute() {
  const { token } = Route.useParams();
  return <SurveyPage token={token} />;
}
